function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { FaPencil, FaPlus, FaTrash } from 'react-icons/fa6';
import { FaCog, FaFile } from 'react-icons/fa';
import Checkbox from '../form/Checkbox.react';
import Confirm from '../modal/Confirm.modal';
var TableRow = function TableRow(_ref) {
  var row = _ref.row,
    table = _ref.table,
    actions = _ref.actions,
    onSelect = _ref.onSelect,
    showModalAction = _ref.showModalAction;
  var _useState = useState(uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var layout = table.layout,
    tr = table.tr,
    rows = table.rows;
  var style = {};
  if (tr.onClick) style['cursor'] = 'pointer';
  return /*#__PURE__*/React.createElement("tr", {
    onClick: function onClick() {
      if (tr.onClick) tr.onClick(row);
    },
    className: "".concat(row.isSelected && 'table__row--selected'),
    style: style
  }, actions && /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '10px 0 10px 10px'
    },
    className: "table__action"
  }, " ", actions.select && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.select.disabled && 'disabled')
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: row.isSelected,
    className: "table__checkbox",
    onChange: function onChange() {
      var _actions$select;
      var selectedRows = rows.filter(function (x) {
        return x.isSelected === true;
      }).map(function (x) {
        return x.id;
      });
      if (((_actions$select = actions.select) === null || _actions$select === void 0 ? void 0 : _actions$select.multiSelect) === true || selectedRows.length === 0 || selectedRows.includes(row.id)) onSelect(row);
    }
  })), actions.edit && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.edit.disabled && 'disabled'),
    onClick: function onClick(e) {
      if (actions.edit.disabled) return;
      e.stopPropagation();
      actions.edit.onEdit(row);
    }
  }, /*#__PURE__*/React.createElement(FaPencil, null)), actions.add && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.add.disabled && 'disabled'),
    onClick: function onClick(e) {
      if (actions.add.disabled) return;
      e.stopPropagation();
      actions.add.onAdd(row);
    }
  }, /*#__PURE__*/React.createElement(FaPlus, null)), actions.settings && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.settings.disabled && 'disabled'),
    onClick: function onClick(e) {
      if (actions.settings.disabled) return;
      e.stopPropagation();
      actions.settings.onClick(row);
    }
  }, /*#__PURE__*/React.createElement(FaCog, null)), actions.file && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.file.disabled && 'disabled'),
    onClick: function onClick(e) {
      if (actions.file.disabled) return;
      e.stopPropagation();
      actions.file.onClick(row);
    }
  }, /*#__PURE__*/React.createElement(FaFile, null)), actions.delete && /*#__PURE__*/React.createElement("div", {
    className: "table__action--icon ".concat(actions.delete.disabled && 'disabled'),
    onClick: function onClick(e) {
      if (actions.delete.disabled) return;
      e.stopPropagation();
      if (actions.delete.requireConfirmation) {
        showModalAction({
          component: /*#__PURE__*/React.createElement(Confirm, {
            onConfirm: function onConfirm() {
              return actions.delete.onDelete(row);
            }
          })
        });
      } else actions.delete.onDelete(row);
    }
  }, /*#__PURE__*/React.createElement(FaTrash, null))), layout.map(function (x) {
    var key = x.key,
      _onClick = x.onClick,
      render = x.render,
      format = x.format,
      td = x.td,
      visible = x.visible;
    if (!visible) return;
    var type = x.type;
    var value = row[key];
    if (type) {
      if (type.label === 'boolean') {
        value = value ? type['true'] || 'On' : type['false'] || 'Off';
      }
    }
    return /*#__PURE__*/React.createElement("td", {
      style: _objectSpread(_objectSpread({}, td.style), _onClick ? {
        cursor: 'pointer'
      } : {}),
      onClick: function onClick() {
        if (_onClick) _onClick({
          row: row,
          key: key
        });
      },
      key: "".concat(id).concat(key)
    }, render && render(row), format && format(row), value === true && /*#__PURE__*/React.createElement("div", {
      className: "table__boolean"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/public/images/icons/checkmark-alt.png"
    })), value === false && /*#__PURE__*/React.createElement("div", {
      className: "table__boolean"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/public/images/icons/x-alt.png"
    })), !render && !format && value);
  }));
};
var mdtp = {
  showModalAction: modalActions.show,
  hideModalAction: modalActions.hide
};
export default connect(null, mdtp)(TableRow);